import { channelCreateReducer } from '@shared/scenes/channel/create/store/reducer';
import { channelDetailsFormReducer } from '@shared/scenes/channel/detailsForm/store/reducer';
import { chatInputReducer } from '@shared/scenes/chat/input/store/reducer';
import { chatLinkPreviewReducer } from '@shared/scenes/chat/linkPreview/store/reducer';
import { notifyPendingUsersReducer } from '@shared/scenes/chat/notifyPendingUsers/store/reducer';
import { chatMessagesReducer } from '@shared/scenes/chat/thread/store/reducer';
import { gifsReducer } from '@shared/scenes/gifs/store/reducer';
import { uploadReducer } from '@shared/scenes/upload/store/reducer';
import { sentryListenerReducer } from '@shared/util/sentry/reducer';
import { appStateReducer } from './appState/reducer';

export const reducers = {
  channelCreate: channelCreateReducer,
  channelDetailsForm: channelDetailsFormReducer,
  chatMessages: chatMessagesReducer,
  chatInput: chatInputReducer,
  chatLinkPreview: chatLinkPreviewReducer,
  gifs: gifsReducer,
  upload: uploadReducer,
  notifyPendingUsers: notifyPendingUsersReducer,
  sentryListener: sentryListenerReducer,
  appState: appStateReducer,
};
